module.exports = __webpack_public_path__ + "img/logo.61a1d4c8.png";